export const FETCH_BRANDS_INIT_ACTION = "FETCH_BRANDS_INIT_ACTION";
export const FETCH_BRANDS_SUCCESS_ACTION =
  FETCH_BRANDS_INIT_ACTION + "_SUCCESS";
export const FETCH_BRANDS_FAIL_ACTION = FETCH_BRANDS_INIT_ACTION + "_ERROR";

export const ADD_BRAND_INIT_ACTION = "ADD_BRAND_INIT_ACTION";
export const ADD_BRAND_SUCCESS_ACTION = ADD_BRAND_INIT_ACTION + "_SUCCESS";
export const ADD_BRAND_FAIL_ACTION = ADD_BRAND_INIT_ACTION + "_ERROR";

export const EDIT_BRAND_INIT_ACTION = "EDIT_BRAND_INIT_ACTION";
export const EDIT_BRAND_SUCCESS_ACTION = EDIT_BRAND_INIT_ACTION + "_SUCCESS";
export const EDIT_BRAND_FAIL_ACTION = EDIT_BRAND_INIT_ACTION + "_ERROR";

export const DELETE_BRAND_INIT_ACTION = "DELETE_BRAND_INIT_ACTION";
export const DELETE_BRAND_SUCCESS_ACTION =
  DELETE_BRAND_INIT_ACTION + "_SUCCESS";
export const DELETE_BRAND_FAIL_ACTION = DELETE_BRAND_INIT_ACTION + "_ERROR";

export const FETCH_ITEMBRANDINACTIVE_INIT_ACTION =
  "FETCH_ITEMBRANDINACTIVE_INIT_ACTION";
export const FETCH_ITEMBRANDINACTIVE_SUCCESS_ACTION =
  FETCH_ITEMBRANDINACTIVE_INIT_ACTION + "_SUCCESS";
export const FETCH_ITEMBRANDINACTIVE_FAIL_ACTION =
  FETCH_ITEMBRANDINACTIVE_INIT_ACTION + "_ERROR";

export function fetchBrands() {
  return {
    type: FETCH_BRANDS_INIT_ACTION
  };
}

export function AddBrand(value) {
  // console.log(value);
  return {
    type: ADD_BRAND_INIT_ACTION,
    value: value
  };
}

export function EditBrand(value) {
  return {
    type: EDIT_BRAND_INIT_ACTION,
    value: value
  };
}

export function DeleteBrand(value) {
  return {
    type: DELETE_BRAND_INIT_ACTION,
    value: value
  };
}

export function brandSlectedPage(value) {
  return {
    type: FETCH_BRANDS_INIT_ACTION,
    value: value
  };
}
export function ItemBrandInActive(value) {
  return {
    type: FETCH_ITEMBRANDINACTIVE_INIT_ACTION,
    value: value
  };
}
